import firedux from '../firedux'

import {
  SCHEDULES_ENDPOINT
} from '../../config/constants'

export default (uid, startTime, endTime, entryType, typeKey = null, payload = null) => {
  if (!uid || !startTime || !endTime || !entryType) return

  const ENDPOINT = `${SCHEDULES_ENDPOINT}/${uid}`

  const obj = {
    type: entryType,
    startTime,
    endTime,
    typeKey,
    payload
  }

  let ref = firedux.ref.child(ENDPOINT).push({})

  return ref.setWithPriority(obj, endTime)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/schedule_entry.js
 **/